import React, { useEffect, useState } from "react"
import "./style.scss"
import arrow from "../../images/arrow.svg"
import Filter from "../cards/filter/Filter"
import { Link } from "gatsby"
import { Box, Divider } from "@material-ui/core"
import { Pagination } from "@material-ui/lab"

const NewsItem = ({ title, news, blogImage, url, category }) => {
  return (
    <div className="news-item">
      <div>
        <img src={blogImage.originalImg} alt={title} />
      </div>
      <div>
        <Link to={url}>
          <h1 className="title" style={{ marginBottom: "0.5rem" }}>
            {title}
          </h1>
        </Link>
        <span className="text" style={{ marginBottom: "0.5rem" }}>
          <strong>{category}</strong>
        </span>
        <p className="text">{news}</p>
        <div className="arrow-div">
          <Link to={url}>
            <img src={arrow} alt="view more" />
          </Link>
        </div>
      </div>
    </div>
  )
}
const Blogs = ({ posts, related_articles }) => {
  const [filterList, setFilterList] = useState([])
  const filters = [
    {
      name: "Artificial Intelligence",
      filters: [],
    },
    {
      name: "Ecommerce",
      filters: [
        { name: "EccomerceTrends" },
        { name: "b2b Ecommerce" },
        { name: "ecommerce personalization" },
        { name: "ecommerce sales " },
        { name: "ecommerce tips" },
        { name: "ecommerce conversation rate" },
        { name: "ecommerce cart abandonment rate" },
      ],
    },
    {
      name: "Big Data",
      filters: [],
    },
    {
      name: "Pricing Intelligence",
      filters: [],
    },
    {
      name: "Industries",
      filters: [],
    },
    {
      name: "Personalization",
      filters: [],
    },
    {
      name: "How To's",
      filters: [],
    },
    {
      name: "News & Events",
      filters: [],
    },
    {
      name: "Guides",
      filters: [],
    },
    {
      name: "Brand Protection",
      filters: [],
    },
    {
      name: "Data Visualization",
      filters: [],
    },
    {
      name: "Data Analytics",
      filters: [],
    },
    {
      name: "Business Intelligence Tool",
      filters: [],
    },
    {
      name: "Web Data Scraping",
      filters: [],
    },
    {
      name: "Brand Analytics",
      filters: [],
    },
  ]

  const handleCheck = e => {
    let value = e.target.value
    let checked = e.target.checked
    if (checked) {
      setFilterList([...filterList, value])
    } else {
      setFilterList(filterList.filter(item => item !== value))
    }
  }
  const reset = () => {
    let checkBoxList = document.getElementsByClassName("filter-box")
    for (let i = 0; i < checkBoxList.length; i++) {
      let checkbox = checkBoxList[i]
      checkbox.checked = false
    }
    setFilterList([])
  }
  let filteredPosts
  if (posts) {
    filteredPosts = posts.filter(item => {
      const { frontmatter } = item.node
      const { category } = frontmatter
      return category
        .toLowerCase()
        .includes(filterList.join(", ").toLowerCase())
    })
  }

  const itemsPerPage = 10
  const [page, setPage] = React.useState(1)
  const [totalPages, setTotalPages] = React.useState()

  const handleChange = (event, value) => {
    setPage(value)
  }

  filteredPosts.sort(function (a, b) {
    return new Date(b.node.frontmatter.date) - new Date(a.node.frontmatter.date)
  })

  useEffect(() => {
    setTotalPages(Math.ceil(filteredPosts.length / itemsPerPage))
  }, [filteredPosts])

  return (
    <div className="our_blogs">
      <h1 className="title top">Blogs</h1>
      <div className="content">
        <div className="filter">
          <Filter reset={reset} handleCheck={handleCheck} filters={filters} />
        </div>
        <div className="blog_content">
          {filteredPosts &&
            filteredPosts
              .slice((page - 1) * itemsPerPage, page * itemsPerPage)
              .map(blog => {
                const { id, frontmatter } = blog.node
                return (
                  <React.Fragment key={id}>
                    <NewsItem
                      title={frontmatter.title}
                      news={frontmatter.description}
                      blogImage={frontmatter.slugImage.childImageSharp.fluid}
                      url={frontmatter.path}
                      category={frontmatter.category}
                    />

                    {/* <RelatedArticles
                    articles={related_articles}
                    responsive={sliderProperties}
                    withoutLock={true}
                  /> */}
                  </React.Fragment>
                )
              })}
          <Divider />
          <Box component="span">
            <Pagination
              count={totalPages}
              page={page}
              onChange={handleChange}
              defaultPage={1}
              color="secondary"
              size="large"
              showFirstButton
              showLastButton
              className="paginationBar"
            />
          </Box>
        </div>
      </div>
    </div>
  )
}

export default Blogs
